import React, {useState, useEffect, useMemo, useRef} from 'react';
import ProtectedRoute from '../../../routes/protected';
import SideBarCompanyManagement from '../../../components/sidebars/sidebarCompanyManagement';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'
import companyService from '../../../services/data/company.service';
import { OrganizationChart } from 'primereact/organizationchart'; //https://primereact.org/organizationchart/
import { Sidebar } from 'primereact/sidebar';
import { AutoComplete } from "primereact/autocomplete";
import { Toast } from 'primereact/toast';
import { Chip } from 'primereact/chip';
import { Badge } from 'primereact/badge';
import { useNavigate } from 'react-router-dom';
import FormImportXlsInternalJobTitle from '../../../components/settings/forms/formImportXlsInternalJobTitle';
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle'


export default function InternalJobsManagement() {

    const [tree, setTree] = useState()
    const [selection, setSelection] = useState();
    const [showSidebar, setShowSidebar] = useState(false);

    const [search , setSearch] = useState('')
    const [items, setItems] = useState([]); // autocomplete
    const [itemsCount, setItemsCount] = useState(0);
    
    const toast = useRef(null);

    const [parent, setParent] = useState('')
    const [jobTitle, setJobTitle] = useState('')

    const [worksheet, setWorksheet] = useState('')

    const navigate = useNavigate()

    const modalRef = useRef()

    const hideModal = () => {
        const modalEl = modalRef.current
        const bsModal= bootstrap.Modal.getInstance(modalEl)
        bsModal.hide()
    }


    useEffect(() => {
        listTitles()
        countItems()
    }, []);

    const searchItems = (event) => {
        if (event.query.length > 0) {

            companyService.autoCompleteInternalJobTitles(event.query).then((response) => {
                
                let resultTitle = response.map((item) => item.title + ' - ' + item.internal_code)
                setItems([...resultTitle])
            })
            .catch((error) => {
                console.log(error.response)
            });

        }
    }

    function listTitles() {
        companyService.listInternalJobTitlesOrg().then((response) => {

            if (response.length > 0) {
                setTree(response)
            }
            
        })
        .catch((error) => {
            console.log(error.response.data)
        });
    }

    function countItems() {
        companyService.countInternalJobTitle().then((response) => {
            setItemsCount(response)
        })
        .catch((error) => {
            console.log(error.response.data)
        });
    }

    function getJobTree() {
        
        companyService.listInternalJobTitlesOrg(search.split('-')).then((response) => {

            if (response.length > 0) {
                setTree(response)
            } else {
                toast.current.show({ severity: 'warn', summary: 'Ops', detail: 'Cargo não encontrado', life: 4000 });
            }
            
        })
        .catch((error) => {
            console.log(error.response.data)
        });
             
    }

    function cleanSearch() {
        setSearch('')
        listTitles() 
    }

    const nodeTemplate = (node) => {
        return (
            <div className="d-flex">
                <div className="p-3">
                    <div className="fw-bold mb-2">{node.data.title}</div>
                    {
                        node.childrenCount > 0 ?
                        <span className='text-secondary'> 
                            <Badge value={node.childrenCount}></Badge>
                            <br/>
                            <small>
                            {
                                node.childrenCount > 1 ?
                                <>Cargos Abaixo</>
                                :
                                <>Cargo Abaixo</>
                            }
                                
                            </small>
                        </span>
                        : null
                    }
                    
                    {
                        node.children.length < 1 && node.childrenCount > 0 ?
                        <button id={node.data.id} className='add-toggler' data-code={node.data.internal_code} onClick={(e) => {setSearch(e.currentTarget.getAttribute('data-code')); getJobTree()}} >
                            <FontAwesomeIcon className='font150 p-node-toggler-icon add-toggle-icon' icon={solid('plus-circle')} />
                        </button>
                        :null
                    }
                </div>
            </div>
        );
    };

    const showTree = useMemo(() => {

        if (tree) {
            return <OrganizationChart className='container-fluid' value={tree} selectionMode="single" selection={selection} onSelectionChange={(e) => {setSelection(e.data); setParent(e.data.data.id); setJobTitle(e.data.data.title); setShowSidebar(true)}} nodeTemplate={nodeTemplate} />
        }
        else {
            return false
        }
        
    }, [tree])

    function editItem() {

        return navigate('/settings/internal-job-management/add-update/', {state: {selection}})
        
    }

    function addItem() {

        return navigate('/settings/internal-job-management/add-update/', {state: {parent, jobTitle}})
        
    }

    useEffect(() => {

        getWorksheet()

    }, [])

    function getWorksheet() {

        let data = {
            key: 'templates/internalJobTitle.xlsx'
        }

        companyService.downloadObject(data).then((response) => {
            setWorksheet(response.data)
        }).catch((error) => {
            console.log(error.response)
        });

    }


    return (
        <ProtectedRoute>
            <div className="container-fluid">
                <div className='row flex-nowrap'>
                    <SideBarCompanyManagement />
                    
                    <div className="col-xs-10 col-sm-9 col-md-9 col-xl-10 p-0 formMarginBottom">
                        
                        <Toast ref={toast} position="top-right" />
                        
                        <div className='col text-bg-green p-3'>
                            <span className="fs-6 fw-bold">Lista de Cargos</span>
                        </div>
                        <div className="row m-3 p-3 justify-content-start">

                            <ul className='nav nav-tabs'>
                                <li className='nav-item'>
                                    <a href='/settings/internal-job-management/' className='nav-link text-green'>
                                        Lista
                                    </a>
                                </li>
                                <li className='nav-item'>
                                    <span className='nav-link active'>
                                        Organograma
                                    </span>
                                </li>
                            </ul>

                            <div className='col bg-white border-clean border-top-0 pb-5 ps-3'>

                                <div className="pt-4 d-flex mb-4">
                                    <div className='col'>
                                        <span className='font120 fw-bold '>
                                            Cargos
                                        </span>
                                        <button id='dbm-addJob' className="btn btn-sm no-caret dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                                            <FontAwesomeIcon className='text-green font150' icon={solid('plus-circle')} />
                                        </button>
                                        <ul className="dropdown-menu border headerBorder font1em" aria-labelledby="dbm-addJob">
                                            <li>
                                                <button className="dropdown-item text-default" data-bs-toggle="modal" data-bs-target="#formImport">
                                                    Adicionar Múltiplos Cargos
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                    
                                    <div className='col'>
                                        <div className='d-flex'>

                                            <div className='p-inputgroup'>
                                                <AutoComplete inputClassName='input-search-radius' placeholder='Buscar Cargo pelo Título ou Código' value={search} suggestions={items} completeMethod={searchItems} onChange={(e) => setSearch(e.value)} />
                                                <button className='btn btn-success button-search-radius' onClick={getJobTree}>
                                                    <FontAwesomeIcon icon={solid('magnifying-glass')} />
                                                </button>
                                            </div>
                                            {
                                                search ?
                                                <button className='btn btn-sm btn-link fw-bold font1em text-grey text-decoration-none' onClick={(e) => cleanSearch()}>
                                                    Limpar
                                                </button>
                                                : null
                                            }
                                            
                                        </div>
                                        
                                    </div>
                                    <hr className='hr-border' />
                                </div>

                                <p className='text-end'><strong>{itemsCount}</strong> Cargos cadastrados</p>
                                {
                                    showTree ?
                                    <div className='pt-3 bg-org rounded'>
                                        {showTree}
                                    </div>
                                    : null
                                }
                                
                            </div>

                            <div className="card flex justify-content-center">
                                <Sidebar className="w-50" visible={showSidebar} position="right" onHide={() => {setShowSidebar(false); setSelection('')}}>
                                    {
                                        selection ?
                                        <>
                                        {
                                        <div>
                                            <p className='lead fw-bold text-default'>
                                                {selection.data.title} <small className='text-grey fw-normal'>({selection.data.internal_code})</small>
                                            </p>
                                            
                                            <div>
                                                <button className='btn btn-sm btn-outline-success btn-rounded px-3 m-1' onClick={editItem} >
                                                    <FontAwesomeIcon icon={solid('edit')} /> Editar
                                                </button>
                                                
                                                <button className='btn btn-sm btn-outline-success btn-rounded px-3 m-1' onClick={addItem}>
                                                    <FontAwesomeIcon icon={solid('plus-circle')} /> Adicionar Cargo Abaixo
                                                </button>
                                            </div>
                                            <hr/>
                                            <div className='py-3'>
                                                <strong>Descrição</strong>
                                                {
                                                    selection.data.description ?
                                                    <p dangerouslySetInnerHTML={{__html: selection.data.description}}></p>
                                                    :
                                                    <p>
                                                    Nenhuma descrição adicionada
                                                    </p>
                                                }
                                            </div>
                                            <div className='py-3'>
                                                <strong>Requisitos</strong>
                                                {
                                                    selection.data.requirements ?
                                                    <p dangerouslySetInnerHTML={{__html: selection.data.requirements}}></p>
                                                    :
                                                    <p>
                                                    Nenhum requisito adicionado
                                                    </p>
                                                }
                                            </div>
                                            <div className='py-3'>
                                                <strong>Competências {selection.competencies.length > 0 ? <>({selection.competencies.length})</> : null}</strong>
                                                
                                                {
                                                    selection.competencies.length > 0 ?
                                                    <div className="d-flex flex-nowrap gap-2 mt-2">
                                                    {
                                                        selection.competencies.map((item , index) => 
                                                            <Chip key={index} label={item.title} />
                                                        )
                                                    }
                                                    </div>
                                                    :
                                                    <p>
                                                    Nenhuma competência adicionada
                                                    </p>
                                                }
                                            </div>
                                            <div className='py-3'>
                                                <strong>Benefícios {selection.benefits.length > 0 ? <>({selection.benefits.length})</> : null}</strong>
                                                
                                                {
                                                    selection.benefits.length > 0 ?
                                                    <div className="d-flex flex-nowrap gap-2 mt-2">
                                                    {
                                                        selection.benefits.map((item, index) => 
                                                            <Chip key={index} label={item.title} />
                                                        )
                                                    }
                                                    </div>
                                                    :
                                                    <p>
                                                    Nenhum benefício adicionado
                                                    </p>
                                                }
                                            </div>
                                            <div className='py-3'>
                                                <strong>Grupos e Permissões</strong>
                                                <hr/>
                                                <strong>Grupos {selection.groups.length > 0 ? <>({selection.groups.length})</> : null}</strong>
                                                {
                                                    selection.groups.length > 0 ?
                                                    <div className="d-flex flex-nowrap gap-2 mt-2">
                                                    {
                                                        selection.groups.map((item, index) => 
                                                            <Chip key={index} label={item.name} />
                                                        )
                                                    }
                                                    </div>
                                                    :
                                                    <p>
                                                    Nenhum grupo adicionado
                                                    </p>
                                                }
                                                <div className='py-3'>
                                                    <strong>Permissões {selection.permissions.length > 0 ? <>({selection.permissions.length})</> : null}</strong>
                                                    {
                                                        selection.permissions.length > 0 ?
                                                        <div className="d-flex flex-nowrap gap-2 mt-2">
                                                        {
                                                            selection.permissions.map((item, index) => 
                                                                <Chip key={index} label={item.name} />
                                                            )
                                                        }
                                                        </div>
                                                        :
                                                        <p>
                                                        Nenhuma permissão adicionada
                                                        </p>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        }
                                        </>
                                        :null
                                    }
                                </Sidebar>
                            </div>

                        </div>
                    </div>

                    <div id="formImport" className="modal fade" ref={modalRef}>
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Importar Múltiplos Cargos</h5>
                                    <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                                </div>
                                <div className="modal-body">
                                    
                                    <div className='mb-3'>
                                        <p>
                                            Utilize e planilha modelo para importar seus cargos 
                                        </p>
                                        <a href={worksheet} target='_blank' rel="noopener noreferrer" className='btn btn-sm btn-success'>
                                            Planilha Modelo
                                        </a>
                                    </div>
                                    <hr/>
                                    <FormImportXlsInternalJobTitle hideModal={hideModal} />
                                </div>
                                <div className='modal-footer'>
                                    <button type="button" className="btn btn-sm btn-secondary" data-bs-dismiss="modal">Cancelar</button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </ProtectedRoute>
    )
}